import { useEffect } from 'react';
import { matchRoutes, useNavigate } from 'react-router-dom';

// Includes links in rendered Markdown, while leaving files and external sites alone.
export default function InternalNavigation({ routes }) {
  const navigate = useNavigate();

  useEffect(() => {
    const onClick = (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest?.('a[href]');
      if (!link || link.hasAttribute('download') || link.hasAttribute('data-reload-document') ||
          (link.target && link.target !== '_self') || link.relList.contains('external')) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || !matchRoutes(routes, url.pathname)) return;
      // Preserve native anchors and their scroll behavior within the current page.
      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;
      event.preventDefault();
      navigate(`${url.pathname}${url.search}${url.hash}`);
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [navigate, routes]);

  return null;
}
